import { Badge } from '@/components/ui/badge';
import type { LucideIcon } from 'lucide-react';

interface JustificationStatProps {
  icon: LucideIcon;
  title: string;
  count: number;
  description: string;
  iconBgColor: string;
  iconTextColor: string;
}

export function JustificationStat({
  icon: Icon,
  title,
  count,
  description,
  iconBgColor,
  iconTextColor
}: JustificationStatProps) {
  return (
    <div className="flex items-start gap-4 p-4 bg-background rounded-lg border shadow-sm">
      <div className={`p-3 rounded-lg ${iconBgColor}`}>
        <Icon className={`h-6 w-6 ${iconTextColor}`} />
      </div>
      <div className="flex-1">
        <div className="flex items-center justify-between mb-1">
          <h4 className="font-semibold text-sm">{title}</h4>
          <Badge variant="secondary">{count}</Badge>
        </div>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
